// extracted by mini-css-extract-plugin
export default {"content":"NewAgentTaskForm-module__content--VKy1a","header":"NewAgentTaskForm-module__header--ov_IU","skeleton":"NewAgentTaskForm-module__skeleton--AzvZ1"};